import { Container, Spin } from './style';

const Spinner = () => {
  return (
    <Container>
      <Spin />
    </Container>
  );
};

export default Spinner;
